import { render, staticRenderFns } from "./Form2_Persona.vue?vue&type=template&id=6a20c777&"
import script from "./Form2_Persona.vue?vue&type=script&lang=js&"
export * from "./Form2_Persona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a20c777')) {
      api.createRecord('6a20c777', component.options)
    } else {
      api.reload('6a20c777', component.options)
    }
    module.hot.accept("./Form2_Persona.vue?vue&type=template&id=6a20c777&", function () {
      api.rerender('6a20c777', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios1/FENORESTE/Form2_Persona.vue"
export default component.exports